import { XCircle } from '@phosphor-icons/react';

export default XCircle;
